export default __webpack_public_path__ + "9f48d8a2d688e0db5af5397cd0a14e6c.jpg";